module.exports = __webpack_public_path__ + "static/SellerDashboard-d5f983e2cee1b118e2e37edac3098698.png";